<template>
    <div class="search-box">
        <div class="search-input-box">
            <div class="search-input">
                <input v-model="searchValue" class="input" placeholder="搜索您想要的商品" type="text"/>
            </div>
            <div class="serch-button">
                <button @click="goSearch(searchValue)"><span class="iconfont icon-sousuo1"></span></button>
            </div>
        </div>
        <nut-drag direction="y" :style="{right:'0px',bottom:'150px'}">
            <nut-fixednav active-text="收起导航" un-active-text="快速导航" :nav-list="NAVLIST" @selected="selectedNav"></nut-fixednav>
        </nut-drag>
    </div>
</template>
<script>
import Tabber from '@/components/Tabber.vue'
export default {
    name: 'Search',
    components: {
        Tabber
    },
    data () { //默认数据
        return {
            recentSearch: [],
            searchValue: '',
        }
    },
    created () { //视图加载前执行
        let _this = this;
    },
    mounted(){ //视图加载完成执行
        let _this = this;
        _this.getRecentSearch();
    },
    methods: {
        /**
         * 获取历史搜索
         */
        getRecentSearch: function() {
            let _this = this;
            _this.recentSearch = _this.$ls.get('recentSearch') ? _this.$ls.get('recentSearch') : [];
        },

        /**
         * 搜索提交
         */
        goSearch: function(item) {
            let _this = this;
            let keywords = item || _this.searchValue;
            if (keywords) {
                // 记录最近搜索
                if(_this.recentSearch.indexOf(keywords) == -1){
                    _this.recentSearch.unshift(keywords);
                    _this.$ls.set('recentSearch', _this.recentSearch)
                }
                // 跳转到商品列表页
                _this.$router.push({path:'/search/list',query:{search:keywords}});
            } else {
                _this.$toast.warn('请输入搜索商品名称');

            }
        },

        /**
         * 清空最近搜索记录
         */
        clearSearch: function() {
            this.recentSearch = [];
            this.$ls.remove('recentSearch');
        },
    },
    destroyed() {
        let _this = this;
　　　　//切记页面销毁需要销毁
        _this.loading.hide();
　　}
}
</script>
<style lang="scss">
    @import "index.scss";
</style>
